import * as tslib_1 from "tslib";
import * as React from 'react';
import Calendar from 'react-calendar';
import { inject, observer } from 'mobx-react';
import TimeOverviewStore from 'src/store/TimeOverviewStore';
import TimeOverviewFilter from './TimeOverviewFilter';
import TimeOverviewElement from './TimeOverviewElement';
import TimeOverviewHeader from './TimeOverviewHeader';
import '../../css/timeoverview.css';
import TaskDialog from '../../components/TaskDialog';
import Main from 'src/layout/Main';
var styles = {
    container: {
        minHeight: '100px'
    }
};
var TimeOverview = /** @class */ (function (_super) {
    tslib_1.__extends(TimeOverview, _super);
    function TimeOverview(props) {
        var _this = _super.call(this, props) || this;
        _this.handleActiveDateChange = function (props) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.state.store.setDate(props.activeStartDate);
                        return [4 /*yield*/, this.state.store.load()];
                    case 1:
                        _a.sent();
                        this.forceUpdate();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleFilterChange = function () {
            _this.forceUpdate();
        };
        _this.handleClick = function (itemId) {
            _this.setState({ isDetailOpen: true, taskId: itemId });
        };
        _this.handleClose = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ isDetailOpen: false });
                        return [4 /*yield*/, this.state.store.load()];
                    case 1:
                        _a.sent();
                        this.forceUpdate();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.tileContent = function (_a) {
            var date = _a.date, view = _a.view;
            if (view !== 'month') {
                return null;
            }
            var items = _this.state.store.itemsByDay(date);
            var elements = items.map(function (i) { return (React.createElement(TimeOverviewElement, { key: i.id, item: i, onClick: _this.handleClick })); });
            var sum = items.reduce(function (total, item) { return total + item.hours; }, 0);
            return (React.createElement("div", { style: styles.container },
                React.createElement(TimeOverviewHeader, { totalHours: sum }),
                elements));
        };
        _this.state = {
            isDetailOpen: false,
            taskId: 0,
            store: new TimeOverviewStore()
        };
        return _this;
    }
    TimeOverview.prototype.componentWillMount = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.state.store.load(this.props.userStore.userId)];
                    case 1:
                        _a.sent();
                        this.forceUpdate();
                        return [2 /*return*/];
                }
            });
        });
    };
    TimeOverview.prototype.render = function () {
        return (React.createElement(Main, null,
            React.createElement("div", { style: { padding: '1rem' } },
                React.createElement(TimeOverviewFilter, { store: this.state.store, onChange: this.handleFilterChange })),
            React.createElement(Calendar, { locale: "hu-HU", className: "sprint-calendar", tileContent: this.tileContent, onActiveDateChange: this.handleActiveDateChange, maxDetail: "month", minDetail: "month" }),
            React.createElement(TaskDialog, { isOpen: this.state.isDetailOpen, taskId: this.state.taskId, onClose: this.handleClose })));
    };
    TimeOverview = tslib_1.__decorate([
        inject('userStore'),
        observer
    ], TimeOverview);
    return TimeOverview;
}(React.Component));
export default TimeOverview;



//////////////////
// WEBPACK FOOTER
// ./src/pages/timeoverview/TimeOverview.tsx
// module id = 783
// module chunks = 0